module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.loading) ? _c('loading') : [(!_vm.error && _vm.campaign) ? [_c('div', {
    staticClass: "map",
    style: ({
      'background-image': ("url(" + _vm.mapPreview + ")")
    })
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row bottom flexible-row"
  }, [_c('div', {
    staticClass: "col-lg-3 d-none d-lg-block d-xl-block"
  }, [_c('h3', {
    staticClass: "campaign-name"
  }, [_vm._v(_vm._s(_vm.campaign.name))])]), _c('div', {
    staticClass: "col-lg-6 align-bottom"
  }), _c('div', {
    staticClass: "col-lg-3 d-lg-none"
  }, [_c('h3', {
    staticClass: "campaign-name"
  }, [_vm._v(_vm._s(_vm.campaign.name))])]), _c('div', {
    staticClass: "col-lg-3 d-none d-lg-block d-xl-block"
  })])])]), _c('campaign')] : (_vm.notFound) ? _c('not-found') : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c86230e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/campaign-wrapper/CampaignWrapper.vue
// module id = 2011
// module chunks = 1